'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var setImagePlaceholder = require('./setImagePlaceholder-8a3080b6.js');
var styles$n = require('./styles-8b576efa.js');

var PromotedContent = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, imageUrl = _a.imageUrl, imageAltText = _a.imageAltText, buttonText = _a.buttonText, onClick = _a.onClick;
    return (React__default.createElement(styles$n.Container, null,
        React__default.createElement(styles$n.Image, { src: "" + constants.IMG_URL + imageUrl, alt: imageAltText !== null && imageAltText !== void 0 ? imageAltText : constants.IMAGE_ALT_TEXT + " " + title, onError: setImagePlaceholder.setImagePlaceholder }),
        React__default.createElement(styles$n.TextBlock, null,
            React__default.createElement(styles$n.Title, null, title),
            React__default.createElement(styles$n.Subtitle, null, subtitle),
            React__default.createElement(styles$n.StyledButton, { text: buttonText, onClick: onClick }))));
};

exports.PromotedContent = PromotedContent;
